import axios from "axios";

export const apiSae = axios.create({
  // baseURL: "http://192.168.1.109:8003/67ZlfPVt",
  baseURL: "https://brk.aclsconnect.com//67ZlfPVt",
  timeout: 4000,
});

// export const urlWebSockt = "http://192.168.1.109:8003";
export const urlWebSockt = "https://brk.aclsconnect.com/";
